import { useState } from 'react';
import { getSyncClient, useSync } from '../sync/syncClient.ts';
import { Button, Sheet } from '../ui/kit.tsx';
import { errorText, toast } from '../ui/toast.tsx';
import { tr } from '../i18n/i18n.ts';

function describe(doc: unknown): string {
  const d = doc as { title?: string; timing?: { kind: string; start: string; end?: string; endExclusive?: string }; deleted?: boolean; done?: unknown } | null;
  if (!d) return tr('Borttagen', 'Deleted');
  if (d.deleted) return tr('Borttagen', 'Deleted');
  const t = d.timing ? (d.timing.kind === 'allDay' ? d.timing.start : d.timing.start.replace('T', ' ')) : '';
  return `${d.title ?? ''} ${t}`.trim();
}

/** Synkkonflikter visas – inget skrivs över tyst. */
export function ConflictBanner() {
  const sync = useSync();
  const [open, setOpen] = useState(false);
  if (!sync.conflicts.length) return null;
  return (
    <>
      <div className="flex flex-wrap items-center gap-3 border-b border-warn/60 bg-warn-bg px-4 py-2 text-sm" role="status">
        <span className="flex-1">
          {tr(
            `${sync.conflicts.length} synkkonflikt${sync.conflicts.length > 1 ? 'er' : ''}: samma post ändrades på två enheter.`,
            `${sync.conflicts.length} sync conflict${sync.conflicts.length > 1 ? 's' : ''}: the same item was changed on two devices.`,
          )}
        </span>
        <Button onClick={() => setOpen(true)}>{tr('Lös', 'Resolve')}</Button>
      </div>
      {open && (
        <Sheet open onOpenChange={setOpen} title={tr('Synkkonflikter', 'Sync conflicts')} description={tr('Välj vilken version som ska gälla. Inget har skrivits över.', 'Choose which version should apply. Nothing has been overwritten.')}>
          <ul className="grid gap-3 text-sm">
            {sync.conflicts.map((c, i) => (
              <li key={i} className="rounded-lg border border-border p-3">
                <p className="font-semibold">{c.title}</p>
                <p className="mt-1"><span className="text-muted">{tr('Denna enhet: ', 'This device: ')}</span>{describe(c.localDoc)}</p>
                <p><span className="text-muted">{tr('Andra enheten (server): ', 'Other device (server): ')}</span>{describe(c.serverDoc)}</p>
                <div className="mt-2 flex gap-2">
                  <Button onClick={() => getSyncClient().resolveConflict(c, 'server').catch((e) => toast({ kind: 'error', text: errorText(e) }))}>{tr('Använd serverns', 'Use the server’s')}</Button>
                  <Button variant="primary" onClick={() => getSyncClient().resolveConflict(c, 'mine').catch((e) => toast({ kind: 'error', text: errorText(e) }))}>{tr('Behåll denna enhets', 'Keep this device’s')}</Button>
                </div>
              </li>
            ))}
          </ul>
        </Sheet>
      )}
    </>
  );
}
